import { Component, OnInit, Directive } from "@angular/core";
import { ModalController, NavParams } from "@ionic/angular";

@Component({
  selector: "app-menuitem",
  templateUrl: "./menuitem.page.html",
  styleUrls: ["./menuitem.page.scss"],
})
export class MenuitemPage implements OnInit {
  paramObject: any;
  buttonPressed: string = "";

  constructor(
    private modalController: ModalController,
    private navParams: NavParams
  ) {}

  ngOnInit() {
    console.table(this.navParams);
    this.paramObject = this.navParams.data.paramObject;
  }

  onButtonPress(buttonPressed: string) {
    
    this.buttonPressed = buttonPressed;
    const onClosedData: string = this.buttonPressed;
    this.closeModal();
  }

  async closeModal() {
    
    if (this.buttonPressed == "") {
      const onClosedData: string = this.buttonPressed;
      await this.modalController.dismiss(null);
    } else {
      await this.modalController.dismiss(this.buttonPressed);
    }
  }
}
